module.exports = __webpack_public_path__ + "static/media/BannerWithImage@2x.d89cabe6085459cc2e7bab6cab54617c.jpg";